import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType, CookieBannerActionType } from '../constants';

export class CookieBannerApplicationEvent implements ApplicationEvent {
  type = ApplicationEventType.CookieBanner;

  constructor(private action: CookieBannerActionType, private state: string) {}

  getPayload(): any {
    return {
      action: this.action,
      state: this.state
    };
  }
}
